import { combineReducers } from 'redux';
import storageSession from 'redux-persist/lib/storage/session'
import localSession from 'redux-persist/lib/storage';
import closeTheLoop from '../../component/screens/closeTheLoop/closeTheLoopReducer'
import loading from '../../component/containers/loader/LoaderReducer'
import ServiceErrorReducer from '../../common/ServiceError/ServiceErrorReducer';
import ctlWebFormReducer from '../../component/containers/ctlWebForm/ctlWebFormReducer';
import totalCommentsDetails from 'component/containers/totalCommentsDetails/totalCommentsDetailsReducer'
import accessDetails from './accessDetailsReducer';

const rootReducer = combineReducers({
    loading: loading,
    closeTheLoop: closeTheLoop,
    serviceError: ServiceErrorReducer,
    ctlWebForm: ctlWebFormReducer,
    totalCommentsDetails: totalCommentsDetails,
    accessDetails: accessDetails
});


const appReducer = (state, action) => {
    if (action.type === 'CLEAR_STORE') {
        storageSession.removeItem(`persist:CTL`);
        localSession.removeItem(`persist:CTL`);
        state = undefined
    }
    if (action.type === 'CLEAR_CLOSETHELOOP') {
        state = { ...state, closeTheLoop: undefined }
    }
    if (action.type === 'CLEAR_SERVICEERROR') {
        state = { ...state, serviceError: undefined }
    }
    if (action.type === 'CTLWEBFORM') {
        state = { ...state, ctlWebForm: undefined }
    }
    if (action.type === 'CLEAR_TOTALCOMMENTSDETAILS') {
        state = { ...state, totalCommentsDetails: undefined }
    }
    if (action.type === 'CLEAR_ALL') {
        state = undefined
    }
    return rootReducer(state, action)
}
export default appReducer;